module.exports = __webpack_public_path__ + "fonts/inter-v11-latin-200.2336227.ttf";